import gql from "graphql-tag";

const queryCreateUser = gql`
  mutation(
    $employeeCode: String
    $email: String!
    $fullname: String!
    $username: String!
    $password: String!
    $positionId: ID
    $departmentId: ID
    $oid: ID
    $status: String
    $adminOfLocationId: ID
  ) {
    createUser(
      data: {
        employeeCode: $employeeCode
        email: $email
        username: $username
        password: $password
        fullname: $fullname
        oid: $oid
        positionId: $positionId
        departmentId: $departmentId
        status: $status
        adminOfLocationId: $adminOfLocationId
      }
    ) {
      id
      email
      fullname
      status
      adminOfLocationId
      position {
        id
        name
      }
      department {
        id
        name
      }
      author {
        id
        fullname
      }
      createdAt
      updatedAt
    }
  }
`;

const queryCreateEmployee = gql`
  mutation(
    $code: String!
    $email: String
    $fullname: String!
    $birthday: DateTime
    $gender: String
    $positionId: ID
    $departmentId: ID
    $userId: ID
  ) {
    createEmployee(
      data: {
        code: $code
        email: $email
        fullname: $fullname
        birthday: $birthday
        gender: $gender
        positionId: $positionId
        departmentId: $departmentId
        userId: $userId
      }
    ) {
      id
      code
      email
      fullname
      birthday
      gender
      status
      concurrentPositions {
        id
      }
      position {
        id
        name
      }
      department {
        id
        name
      }

      user {
        id
        fullname
      }
      author {
        id
        fullname
      }
      createdAt
      updatedAt
    }
  }
`;

export const queryUpdateUser = gql`
  mutation(
    $id: ID!
    $fullname: String!
    $directManagerId: ID
    $status: String
    $adminOfLocationId: ID
  ) {
    updateUser(
      id: $id
      data: {
        fullname: $fullname
        directManagerId: $directManagerId
        status: $status
        adminOfLocationId: $adminOfLocationId
      }
    ) {
      id
      email
      fullname
      employeeId
      directManagerId
      status
      adminOfLocationId
      adminOfLocation {
        id
        name
      }
      author {
        id
        fullname
      }
      createdAt
      updatedAt
    }
  }
`;

const queryDeleteEmployee = gql`
  mutation($id: ID!) {
    deleteEmployee(id: $id) {
      id
    }
  }
`;
const unAssignUserFromEmployee = gql`
  mutation($id: ID!) {
    unAssignUserFromEmployee(id: $id) {
      id
      user {
        id
        fullname
        username
        email
      }
    }
  }
`;

export default {
  queryCreateUser,
  queryDeleteEmployee,
  unAssignUserFromEmployee,
};
